export default {"src":"/_next/static/media/inbox-zero.8a4dc97f.svg","height":577,"width":641};